import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export interface OnboardingChecklistItem {
  title: string;
  status: 'pending' | 'awaiting_review' | 'changes_requested' | 'complete';
}

export interface OnboardingResponse {
  total: number;
  done: number;
  items: OnboardingChecklistItem[];
  uniform_sizes?: Record<string, unknown> | null;
  /** 'all_desks'-tagged form answers, shown on every station (e.g. preferred name). */
  desk_fields?: Record<string, string> | null;
  /** Only present for the onboarding/admin role (full view). */
  captures?: Record<string, unknown>;
}

/**
 * The person's onboarding checklist summary. Shared by
 * OnboardingChecklistCard and the person summary strip; both render
 * from the same react-query cache entry so the endpoint is hit once.
 */
export function usePersonOnboarding(personId: string) {
  return useQuery({
    queryKey: ['person-onboarding', personId],
    queryFn: () => api<OnboardingResponse>(`/api/people/${personId}/onboarding`),
  });
}
